import { fromJS } from 'immutable';
import * as actions from '../utils/Constants';
import rg4js from 'raygun4js';

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case 'AUTHENTICATE_FULFILLED':
            {
                const context = action.payload;

                if (context) {
                    const user = context.user || {};
                    const person = user.person || {};
                    rg4js('setUser', {
                        identifier: user.userName,
                        isAnonymous: false,
                        email: user.email,
                        firstName: person.firstName,
                        fullName: person.displayName,
                        uuid: user.id
                    });
                }

                const signIn = action.payload.signIn;
                return state.withMutations(mut => {
                    mut.set('context', fromJS(action.payload));
                    mut.set('message', signIn ? '' : action.payload  )
                    mut.set('isAuthenticated', (signIn && signIn.succeeded) || false);
                    return mut;
                });
            }
        case actions.UPDATE_USER_CONTEXT + actions.FULFILLED:
            {
                return state.setIn(['context', 'user'], fromJS(action.payload));
            }
        case 'LOGOUT_LOCAL':
        case 'LOGOUT_FULFILLED':
            {
                return getInitialState();
            }
        default:
            return state;
    }
}

const getInitialState = () => {
    return fromJS({
        context: {},
        isAuthenticated: false,
        message: ''
    });
};